var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgZhifu = function SvgZhifu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "url(#zhifu_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.879 7.485c.3-.3.6-.23 1.013-.131.256.06.556.13.926.13.485 0 .728-.12.97-.242.242-.12.485-.242.97-.242.484 0 .727.121.97.242.242.122.484.243.969.243.37 0 .67-.07.926-.131.414-.098.714-.169 1.013.13.468.468.035 2.285-.865 3.718-.857.267-1.929.404-3.014.404-1.085 0-2.156-.137-3.012-.403-.9-1.433-1.333-3.25-.866-3.718Zm3.878 4.606c1.193 0 2.402-.16 3.359-.491 3.505 1.933 4.4 4.69 4.4 6.551V20a3 3 0 0 1-3 3H11a3 3 0 0 1-3-3v-1.849c0-1.862.894-4.618 4.399-6.551.957.33 2.165.491 3.358.491Zm-1.595 2.324a.485.485 0 0 0-.686.685l1.597 1.597h-2.224a.485.485 0 1 0 0 .97h2.425v.97h-2.425a.485.485 0 1 0 0 .97h2.425v1.454a.485.485 0 1 0 .97 0v-1.455h2.424a.485.485 0 0 0 0-.97h-2.425v-.97h2.425a.485.485 0 0 0 0-.969h-2.224l1.597-1.597a.485.485 0 0 0-.686-.685l-1.597 1.596-1.596-1.596Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "zhifu_svg__a",
    x1: 15.5,
    y1: 0,
    x2: 15.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64DEC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BC7A5"
  })))));
};

export default SvgZhifu;